import { CloseCircleFilled } from '@ant-design/icons';
import { ReactNode } from 'react';
import styles from './index.module.scss';
import { Themes } from '@maxtropy/components';
interface Iprops {
  children: ReactNode;
  borderBg?: string;
  onClose?: () => void;
  showClose?: boolean;
  theme?: Themes;
}
const ShiftTag: React.FC<Iprops> = ({ borderBg, children, onClose, theme, showClose = true }) => {
  return (
    <>
      <div
        className={styles.tag_box}
        style={{
          backgroundColor: `color-mix(in srgb, ${borderBg} 10%, transparent)`,
          borderColor: borderBg,
          color: theme === Themes.DARK ? 'var(--mx-text-base-color)' : borderBg,
        }}
      >
        <div className={styles.text}>{children}</div>
        {showClose && (
          <div className={styles.icon} onClick={() => onClose?.()}>
            <CloseCircleFilled />
          </div>
        )}
      </div>
    </>
  );
};
export default ShiftTag;
